import { render } from "./index.vue?vue&type=template&id=0559dcb0&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.less?vue&type=style&index=0&id=0559dcb0&lang=less&scoped=true"

import exportComponent from "/Users/jinzhouhang/work/zhanhai/ypin-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0559dcb0"]])

export default __exports__